import React, {Component} from 'react'
import FJTimeline from 'fj-components/FJTimeLine';
import {connect} from 'react-redux'
import {FJMediaAction, FJPreviewAction, FJTimeLineAction} from '../../../redux/action/FJRoot.action'
import FJTimelineStore from "fj-timeline";
import key from "keymaster";
import FJActionConstant from "../../../constant/FJActionConstant";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJMultiProcessContainer from "./FJMultiProcessContainer";
import FJThumbnailContainer from "./FJThumbnailContainer";
import FJTimelineTagBoxContainer from "./FJTimelineTagBoxContainer";
import FJTimelineToolContainer from "./FJTimelineToolContainer";
import FJTimelineToolLeftContainer from "./FJTimelineToolLeftContainer";
import FJCanvasStore from '../../../store/FJCanvasStore'
import FJMediaStore from '../../../store/FJMediaStore'
import FJConfig from '../../../config/FJConfig'
import FJLocalStore from '../../../store/FJLocalStore';
import styles from '../css/FJTimelineContainer.module.less'
import FJUtil from "../../../util/FJUtil";
import ElementIcon from '../../../icon/element-timeline.svg';
import TextIcon from '../../../icon/text-timeline.svg';
import OverLayIcon from '../../../icon/overlay-timeline.svg'
import {FJTransitionStore} from "fj-graph";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJEventConstant from "../../../constant/FJEventConstant";
import FJAdsorptionContainer from "./FJAdsorptionContainer";

class FJTimelineContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      topHeight: 0,
      bottomHeight: 0,
      width: 0,
    }

		this._transitions = FJTransitionStore.getAllTransitionData();

		this.audioWaveConfig = {
			background: '#D9F7EE',
			waveBackground: '#00C8A0',
			isShowAudioName: true,
		};

    this.config = {
			mainTrackHeight: FJConfig.mainTrackHeight,
			mainTrackTip: FJLocalStore._('main-track-tip'),
			audioTrackTip: FJLocalStore._('bgm-track-tip'),
			isOpenTimeLineIcon: true,
			allTooltip: this._allTooltip,
			textTip: FJLocalStore._('replace text'),
			elementTip: FJLocalStore._('replace element'),
			overlayTip: FJLocalStore._('replace overlay'),
			toggleTooltip: this._toggleTooltip,
			isShowShade: true,
			elementIcon: ElementIcon,
			overlayIcon: OverLayIcon,
			textIcon: TextIcon,
			dragDisplayContent: false,
			isShowTransition: true,
			openCustomizationStyle: true,
			customizationTextStyle: true,
			transitionConfig: {
				showTransition: true,
				delBtnContent: FJLocalStore._('delete'),
				applyBtnContent: FJLocalStore._('apply'),
				volumeContent: FJLocalStore._('duration'),
				secContent: FJLocalStore._('sec'),
				applyErrorTips: FJLocalStore._('apply-transition-error-tips')
			}
		};

    this.classes = {
			boxClassName: styles.timeline_box,
			timelineClasses: {
				mainTrackClassName: styles.main_track,
				trackTextClassName: styles.track_text,
				bottomMaskClassName: styles.bottom_mask,
        adsorptionClassName: styles.adsorption,
        scrollClasses: {
					trackVertical: styles.scroll_vertical_track,
					trackHorizontal: styles.scroll_horizontal_track,
					thumbVertical: styles.scroll_vertical_thumb,
					thumbHorizontal: styles.scroll_horizontal_thumb
				},
				lineCommonClasses: {
					borderClassName: styles.border,
					timelineHandleClassName: styles.timeline_handle,
					lineClassName: styles.line_class,
					lineLeftClassName: styles.line_left,
					lineRightClassName: styles.line_right,
					shadeLeftClassName: styles.line_shade_left_box,
					shadeRightClassName: styles.line_shade_right_box,
					replaceClassName: styles.replace_mask,
					placeHolderClass: {
						placeHolderContentClassName: styles.place_holder_content,
					},
					timeLineCommonContainerClassName: styles.common_container,
					IconClassName: styles.IconClassName,
					textContentClassName: styles.time_line_text_content,
					audioNameClassName: styles.audio_name
				},
				mountTimeLineClasses: {
					line_to_main: styles.line_to_main,
					line_to_main_top: styles.line_to_main_top,
					line_to_main_bottom: styles.line_to_main_bottom,
				},
			}
		};
  }

  componentDidMount() {
    this.updateLayout();
    this.updateLayoutUnsubscribe = window.FJEvent.subscribe(FJActionConstant.EVENT_TIMELINE_LAYOUT, this.updateLayout);
    this.updateTimelineUnsubscribe = window.FJEvent.subscribe(FJEventConstant.UPDATE_TIMELINE, this.props.updateAllTimeline);
    this.deSelectTimeLineUnsubscribe = window.FJEvent.subscribe(FJCoreConstant.DE_SELECT_TIMELINE, this._deSelectTimeLine);

    key('delete, backspace', 'default', this.deleteSelectedTimeline);
  }

  componentWillUnmount() {
    this.updateLayoutUnsubscribe();
    this.deSelectTimeLineUnsubscribe();
    this.updateTimelineUnsubscribe();
    key.unbind('delete, backspace', 'default');
  }

	/**
	 * @description 处理转场数据获取本地化
	 * @param data
	 * @returns {{length}|*}
	 */
	transitionHandle = (data) => {
  	if (data.length) {
			let __lists = [];
			this._transitions.forEach(item => {
				item.items.forEach(list => {
					__lists.push({
						name: list.name,
						label: list.label
					})
				})
			})
			data.forEach(item => {
				// 验证转场的入场和出场是否对应
				// let inBrickIndex = this.props.bricks.mainLayer.findIndex(layer => layer.id === item.inKey);
				// let outBrick     = this.props.bricks.mainLayer[inBrickIndex + 1];
				// item.display = !(outBrick && outBrick.id !== item.outKey);
				let __result = __lists.filter(value => item.name === value.name);
				if (__result.length) {
					item.title = FJLocalStore._(__result[0].label);
				}
			})
		}
		return data;
	}

  deleteSelectedTimeline = () => {
    let {deleteSelectedTimeline, selectedId, isDragging} = this.props;
    if (isDragging) {
      return
    }
    deleteSelectedTimeline(selectedId);
  };

  /**
   * @description 取消选中
   * @private
   */
  _deSelectTimeLine = () => {
    this.props.selectTimeLine(-1);
  };

  updateLayout = () => {
    setTimeout(() => {
      let {
        bricks,
      } = this.props;
      let {subLayer, subAudioLayer} = bricks;
      let topHeight = FJTimelineStore.calcRectHeight(subLayer);
      let bottomHeight = FJTimelineStore.calcRectHeight(subAudioLayer);
      this.setState({
        topHeight,
        bottomHeight,
      });
      this.props.updateTime();
    })
  };

  _getTextById = (id) => {
    let graph = FJCanvasStore.executeSync(FJCanvasStore.command.GET_GRAPHS_BY_ID, id);
    return  (graph && graph.getTextData) ? graph.getTextData().join(',') : '';
  };

  _getAudioUrlById = (sourceId) => {
    let media = FJMediaStore.getMediaById(sourceId);
    return media && media.getMediaCache() && media.getMediaCache().getUrl();
  };

  _renderVideoThumbnail = (id, canvas)=> {
    return FJCanvasStore.executeSync(FJCanvasStore.command.RENDER_THUMBNAIL, id, canvas)
  };

  _allTooltip = (element) => {
    if (element) {
      FJUtil.oneTooltip(element, 'bottom', {trigger: 'click'});
    }
  };

  _toggleTooltip = (element, toggle) => {
    if (element) {
      FJUtil.toggleTooltip(element, toggle);
    }
  }

	/**
	 * @description 滚动条滚动时的操作
	 * @private
	 */
	_eventScroll = () => {
		FJCoreUtil.triggerBodyMousedown()
	}

	_mediaRetry = (id) => {
		this.props.retryMedia(id);
	}

	_renderSub = {
    renderMultiProcess: (props) => {
      return <FJMultiProcessContainer {...props} />
    },
    renderThumbnail: (props) => {
      return <FJThumbnailContainer {...props} />
    },
    renderTimelineTagBox: (props) => {
      const {bricks} = props;
      return <FJTimelineTagBoxContainer isMainLayerEmpty={bricks.mainLayer.length === 0} />
    },
    renderTimelineTool: (props) => {
      const {renderTimelineToolLeft, ref} = props;
      return <FJTimelineToolContainer ref={ref} renderTimelineToolLeft={renderTimelineToolLeft} />
    },
    renderTimelineToolLeft: (props) => {
      return  <FJTimelineToolLeftContainer {...props} />
    }
  };

	_actions = {
    dragTimeLine: null,
    selectTimeLine: null,
    setDraggingState: null,
    getTextById: this._getTextById,
    getAudioUrlById: this._getAudioUrlById,
    renderVideoThumbnail: this._renderVideoThumbnail,
    onDeleteTransition: this.props.onDeleteTransitionAction, // 删除转场
    onApplyTransition: this.props.onApplyTransitionAction, // 应用转场
    stop: this.props.stopAction,
    eventScroll: this._eventScroll,
    mediaRetryClick: this._mediaRetry
  };

	_renderAdsorption = (FJAdsorptionLine) => {
	  return <FJAdsorptionContainer className={this.classes.timelineClasses.adsorptionClassName}
                                  FJAdsorptionLine={FJAdsorptionLine} />
  };

  render() {
    let {
      bricks,
      selectedId,
      selectTimeLine,
      isDragging,
      dragTimeLine,
      setDraggingState,
      height,
      isPlaying,
      unitConversion,
      isCoverEle,
      transitions,
    } = this.props;

    let {
      topHeight,
      bottomHeight,
    } = this.state;

    let {mainLayer, subLayer, subAudioLayer} = bricks;
    let width = FJTimelineStore.calcRectWidth([...mainLayer, ...subLayer, ...subAudioLayer]);

    this._actions.dragTimeLine = dragTimeLine;
    this._actions.selectTimeLine = selectTimeLine;
    this._actions.setDraggingState = setDraggingState;

    return <FJTimeline bricks={bricks}
                       transitions={this.transitionHandle(transitions)}
                       bricksWidth={width}
                       topHeight={topHeight}
                       bottomHeight={bottomHeight}
                       selectedId={selectedId}
                       isDragging={isDragging}
                       isPlaying={isPlaying}
                       height={height}
                       unitConversion={unitConversion}
                       classes={this.classes}
                       config={this.config}
                       action={this._actions}
                       component={this._renderSub}
                       audioWaveConfig={this.audioWaveConfig}
                       isCoverEle={isCoverEle}
                       renderAdsorption={this._renderAdsorption}
    />
  }
}

const mapStateToProps = function (state) {
  return {
    bricks: state.timeline.bricks,
    transitions: state.timeline.transitions,
    selectedId: state.timeline.selectedId,
    draggingId: state.timeline.draggingId,
    isDragging: state.timeline.isDragging,
    isPlaying: state.preview.isPlaying,
    unitConversion: state.timeline.unitConversion,
    isCoverEle: state.timeline.isCoverEle,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    selectTimeLine: function (id) {
      dispatch(FJTimeLineAction.selectTimeLineAction(id));
    },
    dragTimeLine: function (id, data) {
      dispatch(FJTimeLineAction.dragTimeLineAction(id, data))
    },
    updateAllTimeline: function () {
      dispatch(FJTimeLineAction.updateAllTimelineAction());
    },
    setDraggingState: function (bool) {
      dispatch(FJTimeLineAction.setDraggingStateAction(bool));
    },
    deleteSelectedTimeline: function (id) {
      dispatch(FJTimeLineAction.deleteTimelineAction(id));
    },
    updateTime: function () {
      dispatch(FJTimeLineAction.updateDurationAction());
    },
		onDeleteTransitionAction: function (id) {
      dispatch(FJTimeLineAction.deleteTransitionAction(id));
		},
		onApplyTransitionAction: function (id, duration) {
      dispatch(FJTimeLineAction.changeTransitionDurationAction(id, duration));
		},
		stopAction: function () {
			dispatch(FJPreviewAction.setVideoPauseAction());
		},
	  retryMedia: function (id) {
		  dispatch(FJMediaAction.retryMediaAction(id));
	  }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJTimelineContainer);
